import clsx from "clsx";
import { Button } from "@/shared/ui";
import { Entity } from "@/domains/createEntity/constants/entity";
import { entityIcon } from "@/domains/createEntity/helpers/entityIcon";

type Props = {
  items: { value: Entity; label: string }[];
  value?: Entity;
  onChange: (value: Entity) => void;
};

export default function CreateEntityMenu({ items, value, onChange }: Props) {
  return (
    <div
      className={clsx(
        "flex items-center",
        "bg-gradient-to-r from-dark-900/80 to-dark-900/90",
        value ? "rounded-s-[1rem]" : "rounded-[1rem]",
      )}
    >
      <div className="flex flex-col items-center gap-1.5 w-[4rem] p-2.5 rounded-[1rem] bg-dark-800 h-full">
        {items.map((item) => {
          const iconProps = entityIcon[item.value];
          const TabIcon = iconProps.icon;

          return (
            <Button
              key={item.value}
              color={item.value === value ? "accent" : "gray"}
              variant={item.value === value ? "solid" : "soft"}
              className={clsx("relative w-[2.75rem] h-[2.75rem] p-0 group")}
              onClick={() => onChange(item.value)}
            >
              <TabIcon
                size={20}
                className={clsx(item.value === value ? "text-white" : "text-white/60")}
              />
              <div
                className={clsx(
                  "absolute right-[3.2rem] bg-dark-900/80 text-white rounded-s-[0.625rem] px-3.5 py-3",
                  "group-hover:opacity-100 opacity-0 transition-all duration-100",
                )}
              >
                {item.label}
              </div>
            </Button>
          );
        })}
        <div className="text-14 text-white/60 font-bold uppercase pt-1">F12</div>
      </div>
      <div className="text-11 font-extrabold text-white uppercase [writing-mode:vertical-rl] m-auto p-2.5 shrink-0">
        ДОБАВЛЕНИЕ ОБЪЕКТОВ
      </div>
    </div>
  );
}
